exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".section-connection-lost{width:100%;height:100vh;display:flex;align-items:center;justify-content:center}.proceed-btn button{border-radius:5px;font-size:14px;height:50px;text-align:center;color:#fff!important;border:2px solid transparent;font-weight:700;background:linear-gradient(179.89deg,#3876d2 .72%,#3876d2 216.45%)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-b48ec288","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/component/connectionLost.vue
// module id = 1782
// module chunks = 0